// Gender enum for FlexPlan, to be used in Dropdowns, etc
export enum Gender {
    Male = "Male",
    Female = "Female",
    Other = "Other",
    PreferNotToSay = "PreferNotToSay"
}
